export default __webpack_public_path__ + "static/media/hydrologicalmodelling.173df1e9.png";